import {
  baseScreen,
} from 'hoc';
import React,
{
  useRef,
  useState,
} from 'react';
import GeneralTableView from 'src/components/GeneralTableView';
import i18n from 'i18n-js';
import {
  useStores,
} from 'hooks';
import {
  toJS,
} from 'mobx';
import {
  FilterTypes,
  TableColumnTypes,
} from 'src/components/GeneralTableView/types';
import {
  useHistory,
} from 'react-router';
import {
  Assets,
} from 'assets';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import {
  BillStatus,
} from 'src/stores/backend/BillsStore/types';
import {
  Button,
} from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import DateRange from 'src/components/DateRange';
import SearchFilterDropdown from 'src/components/SearchFilterComponent';
import {
  Bill,
} from '../doctors/types';
import {
  ListFilter,
} from './types';

const hospitalsBalance: React.FC = () => {
  const {
    backend: {
      billsStore,
    },
  } = useStores();
  const ref = useRef<any|null>(null);
  const [
    filterDisplayed,
    setFilterDisplayed,
  ] = useState(false);
  const [
    range,
    setRange,
  ] = useState<{
    min: Date,
    max: Date,
  }>({} as any);
  const [
    currentFilter,
    setCurrentFilter,
  ] = useState<ListFilter>(ListFilter.ALL);
  const onFilterChange = (val: ListFilter) => {
    setCurrentFilter(val);
    ref.current?.onQueryChange();
  };
  const history = useHistory();
  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: 16,
          cursor: 'pointer',
        }}
        onClick={() => setFilterDisplayed(!filterDisplayed)}
        tabIndex={0}
        role="button"
        onDoubleClick={() => {
          setFilterDisplayed(!filterDisplayed);
        }}
        onKeyDown={() => {
        }}
      >
        <span
          style={{
            marginLeft: 20,
            marginRight: 20,
          }}
        >
          {i18n.t('FILTER')}
        </span>
        <FilterListIcon />
      </div>
      {filterDisplayed && (
        <div>
          <SearchFilterDropdown
            label="Filter"
            style={{
              margin: 16,
            }}
            searchFilterDropdown={{
              filters: [
                {
                  name: i18n.t('ALL'),
                  value: 'all',
                },
                {
                  name: i18n.t('HOME_VISITS'),
                  value: ListFilter.HOME_VISIT,
                }, {
                  name: i18n.t('ONLINE_CONSULTATION'),
                  value: ListFilter.ONLINE_CONSULTATION,
                },
                {
                  name: i18n.t('CLINICS'),
                  value: ListFilter.CLINICS,
                },
              ],
              value: currentFilter || ListFilter.ALL,
              initialValue: currentFilter || ListFilter.ALL,
              onChange: onFilterChange,
            }}
          />
          <DateRange
            onChange={async (start, end) => {
              await setRange({
                min: start,
                max: end,
              });
              ref.current?.onQueryChange();
            }}
          />
          <div
            style={{
              justifyContent: 'flex-end',
              display: 'flex',
              marginBottom: 16,
            }}
          >
            <Button
              style={{
                background: '#3f51b5',
                color: '#FFF',
              }}
              onClick={async () => {
                await setFilterDisplayed(false);
                await setRange({} as any);
                await setCurrentFilter(ListFilter.ALL);
                ref.current?.onQueryChange();
              }}
            >
              {i18n.t('RESET')}
            </Button>
          </div>
        </div>
      )}

      <GeneralTableView<Bill>
        tableProps={{
          tableRef: ref,
          options: {
            actionsColumnIndex: 10,
            search: true,
            paging: true,
          },
          title: i18n.t('BALANCE'),
          actions: [
            {
              isFreeAction: true,
              icon: ImportExportIcon,
              onClick: () => {
                window.open(billsStore.download(), '_blanck');
              },
              tooltip: i18n.t('EXPORT_DATA'),
            },
            {
              icon: () => (
                <img
                  src={Assets.images.common.eye}
                  alt={i18n.t('VIEW')}
                />
              ),
              onClick: async (ev, data) => {
                const bill: any = data;
                history.push(`/balance/balance/hospitals/monthly-breakdown/${bill.serviceProviderId}`);
              },
            },
          ],
        }}
        options={{
          search: false,
          pageSize: 10,
          filtering: false,
        }}
        get={async (query) => {
          const queryObj: any = {
            ...query,
            filters: [
              {
                type: 'FIXED',
                by: 'type',
                value: 'service_providers',
              },
            ],
          };
          if (currentFilter !== ListFilter.ALL) {
            queryObj.filters.push({
              type: 'FIXED',
              by: 'consultation_type',
              value: currentFilter,
            });
          }
          if (range.min) {
            queryObj.filters.push({
              type: 'RANGE',
              by: 'date',
              min: range.min,
              max: range.max,
            });
          }
          await billsStore.entityList.updateOptions(queryObj);
          return {
            data: toJS(billsStore.entityList.data).map((item) => new Bill(item)),
            totalCount: billsStore.entityList.meta.itemCount,
            page: billsStore.entityList.meta.page - 1,
          };
        }}
        tableColumns={[
          {
            field: 'id',
            title: i18n.t('ID'),
            type: TableColumnTypes.NUMERIC,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'date',
            title: i18n.t('DUE_DATE'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'service_provider_name',
            title: i18n.t('SERVICE_PROVIDER'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'service_provider_type',
            title: i18n.t('TYPE'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'mobileNumber',
            title: i18n.t('MOBILE_NUMBER'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'balance',
            title: i18n.t('BALANCE'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'status',
            title: i18n.t('STATUS'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
            columnProps: {
              render: (data) => (data.status === BillStatus.SETTLED
                ? (<p>{data.status}</p>) : (
                  <Button
                    onClick={() => {
                      history.push(`/balance/hospitals/settlement/${data.id}`);
                    }}
                    style={{
                      background: '#3f51b5',
                      color: '#FFF',
                    }}
                  >
                    {i18n.t('SETTLE')}
                  </Button>
                )),
            },
          },
        ]}
      />
    </div>
  );
};

export const HospitalsBalance = baseScreen(hospitalsBalance, {
  allowedRoles: ['ADMIN', 'NONE'],
});
